import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import jwtDecode from 'jwt-decode';

import { updateAllowedPath } from 'src/store/modules/paths';

import api from './services/api';
import { useDispatch } from 'react-redux';
import { useCallback } from 'react';

function PrivateRoute({ component: Component, ...rest }) {
  const location = useLocation();

  const dispatch = useDispatch();

  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isAllowed, setIsAllowed] = useState(null);

  const { token } = useSelector((state) => state.user);
  const { allowedPaths } = useSelector((state) => state.paths);

  const fetchAllowed = useCallback(async () => {
    try {
      await api.post(`/possuiPermissao`, {
        rota: location.pathname,
      });

      setIsAllowed(true);

      dispatch(
        updateAllowedPath({
          path: location.pathname,
          isAllowed: true,
        })
      );
    } catch (err) {
      setIsAllowed(false);

      dispatch(
        updateAllowedPath({
          path: location.pathname,
          isAllowed: false,
        })
      );
    }
  }, [dispatch, location.pathname]);

  // verifica se token ainda é válido e seta se usuário está autenticado
  useEffect(() => {
    const fetchAuthenticated = async () => {
      if (token) {
        const tokenExpiration = jwtDecode(token).exp;
        const dateNow = new Date();

        if (tokenExpiration < dateNow.getTime() / 1000) {
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      } else {
        setIsAuthenticated(false);
      }
    };

    fetchAuthenticated();
  }, [token]);

  // verifica se usuário tem permissão para acessar a rota
  useEffect(() => {
    if (allowedPaths[location.pathname] === undefined) {
      fetchAllowed();
    } else {
      setIsAllowed(allowedPaths[location.pathname]);
    }
  }, [allowedPaths, location.pathname, fetchAllowed]);

  if (isAuthenticated === null) {
    return <></>;
  }

  if (!isAllowed && isAuthenticated) {
    return <></>;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        !isAuthenticated ? <Redirect to="/login" /> : <Component {...props} />
      }
    />
  );
}

PrivateRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.node, PropTypes.elementType]),
};

export default PrivateRoute;
